// extracted by mini-css-extract-plugin
export default {"toolbar":"style_toolbar__ammWc","grid":"style_grid__WIUZ7"};